// extracted by mini-css-extract-plugin
export var graphic = "hero-module--graphic--2RK1X";
export var hero = "hero-module--hero--2U58p";